export default __webpack_public_path__ + "static/media/logo-22-kapama.f171c7e6.png";